// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function PageTransition(props) {
  React.useState(function () {
        return false;
      });
  return React.createElement(React.Fragment, {
              children: Caml_option.some(React.createElement("div", {
                        className: "absolute top-0 left-0 w-screen h-screen overflow-y-scroll snap-y snap-mandatory"
                      }, props.children))
            });
}

var make = PageTransition;

export {
  make ,
}
/* react Not a pure module */
